export const KEYBOARD_KEYS = {
    ENTER: "Enter",
    BACKSPACE: "Backspace",
    SPACE: " ",
    DELETE: "Delete",
    LEFT: "ArrowLeft",
    UP: "ArrowUp",
    RIGHT: "ArrowRight",
    DOWN: "ArrowDown",
    Z: "Z",
    Y: "Y",
    COMMA: ",",
    ESCAPE: "Escape",
    TAB: "Tab",
} as const;
